module.exports = __webpack_public_path__ + "img/98.1c513571.jpg";